export class StudentTelehealthModel {
	status: number;
}
